import { render, staticRenderFns } from "./GlobalNewsPage.vue?vue&type=template&id=6b31f002&scoped=true&"
import script from "./GlobalNewsPage.vue?vue&type=script&lang=js&"
export * from "./GlobalNewsPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b31f002",
  null
  
)

export default component.exports